"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.AsyncSelect = exports.Select = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_select_1 = __importStar(require("react-select"));
var async_1 = __importDefault(require("react-select/async"));
var uuid_1 = require("uuid");
var component_library_1 = require("@kaizen/component-library");
var chevron_down_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/chevron-down.icon.svg"));
var chevron_up_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/chevron-up.icon.svg"));
var clear_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/clear.icon.svg"));
var draft_form_1 = require("@kaizen/draft-form");
var draft_tag_1 = require("@kaizen/draft-tag");
var Select_module_scss_1 = __importDefault(require("./Select.module.scss"));
/**
 * {@link https://cultureamp.design/components/select/ Guidance} |
 * {@link https://cultureamp.design/storybook/?path=/docs/components-select--default-select-story Storybook}
 */
exports.Select = react_1["default"].forwardRef(function (props, ref) {
    var _a = props.variant, variant = _a === void 0 ? "default" : _a, _b = props.status, status = _b === void 0 ? "default" : _b, _c = props.reversed, reversed = _c === void 0 ? false : _c, label = props.label, validationMessage = props.validationMessage, description = props.description;
    // the default for fullWidth depends on the variant
    var fullWidth = props.fullWidth != null
        ? props.fullWidth
        : variant === "secondary" || variant === "secondary-small"
            ? false
            : true;
    var classes = (0, classnames_1["default"])(props.className, Select_module_scss_1["default"].specificityIncreaser, (!reversed || variant === "default") && Select_module_scss_1["default"]["default"], reversed && Select_module_scss_1["default"].reversed, variant === "secondary" && Select_module_scss_1["default"].secondary, variant === "secondary-small" && Select_module_scss_1["default"].secondarySmall, !fullWidth && Select_module_scss_1["default"].notFullWidth, props.isDisabled && Select_module_scss_1["default"].disabled, status === "error" && Select_module_scss_1["default"].error);
    var labelId = (0, react_1.useState)(label ? (0, uuid_1.v4)() : undefined)[0];
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        label ? (react_1["default"].createElement(draft_form_1.Label, { reversed: reversed, id: labelId }, label)) : null,
        react_1["default"].createElement(react_select_1["default"], __assign({}, props, { ref: ref, "aria-labelledby": labelId, components: {
                Control: Control,
                Placeholder: Placeholder,
                DropdownIndicator: DropdownIndicator,
                Menu: Menu,
                GroupHeading: GroupHeading,
                Option: Option,
                NoOptionsMessage: NoOptionsMessage,
                Input: Input,
                SingleValue: SingleValue,
                MultiValue: MultiValue,
                IndicatorsContainer: IndicatorsContainer,
                ValueContainer: ValueContainer,
                ClearIndicator: ClearIndicator,
                IndicatorSeparator: null
            }, className: classes })),
        validationMessage ? (react_1["default"].createElement(draft_form_1.FieldMessage, { message: validationMessage, status: status })) : null,
        description ? react_1["default"].createElement(draft_form_1.FieldMessage, { message: description }) : null));
});
exports.Select.displayName = "Select";
exports.AsyncSelect = react_1["default"].forwardRef(function (props, ref) { return (react_1["default"].createElement(async_1["default"], __assign({}, props, { ref: ref, components: {
        Control: Control,
        Placeholder: Placeholder,
        DropdownIndicator: DropdownIndicator,
        Menu: Menu,
        Option: Option,
        NoOptionsMessage: NoOptionsMessage,
        Input: Input,
        SingleValue: SingleValue,
        MultiValue: MultiValue,
        IndicatorsContainer: IndicatorsContainer,
        ValueContainer: ValueContainer,
        ClearIndicator: undefined,
        IndicatorSeparator: null,
        LoadingMessage: LoadingMessage
    }, className: (0, classnames_1["default"])(Select_module_scss_1["default"].specificityIncreaser, props.className) }))); });
exports.AsyncSelect.displayName = "AsyncSelect";
var Control = function (props) { return (react_1["default"].createElement("div", { "data-automation-id": "Select__Control" },
    react_1["default"].createElement(react_select_1.components.Control, __assign({}, props, { className: (0, classnames_1["default"])(Select_module_scss_1["default"].control, props.isFocused && Select_module_scss_1["default"].focusedControl, props.isDisabled && Select_module_scss_1["default"].disabled) })))); };
var Placeholder = function (props) { return (react_1["default"].createElement(react_select_1.components.Placeholder, __assign({}, props, { className: Select_module_scss_1["default"].placeholderOverrides }),
    react_1["default"].createElement("span", { className: Select_module_scss_1["default"].placeholder }, props.children))); };
var DropdownIndicator = function (props) { return (react_1["default"].createElement(react_select_1.components.DropdownIndicator, __assign({}, props, { className: Select_module_scss_1["default"].dropdownIndicator }),
    react_1["default"].createElement(component_library_1.Icon, { icon: props.selectProps.menuIsOpen ? chevron_up_icon_svg_1["default"] : chevron_down_icon_svg_1["default"], role: "presentation" }))); };
var LoadingMessage = function (props) { return (react_1["default"].createElement(react_select_1.components.LoadingMessage, __assign({}, props, { className: Select_module_scss_1["default"].loadingMessage }))); };
var Menu = function (props) { return (react_1["default"].createElement(react_select_1.components.Menu, __assign({}, props, { className: Select_module_scss_1["default"].menu }))); };
var GroupHeading = function (props) { return (react_1["default"].createElement(react_select_1.components.GroupHeading, __assign({}, props, { className: Select_module_scss_1["default"].groupHeading }))); };
var Option = function (props) { return (react_1["default"].createElement("div", { "data-automation-id": "Select__Option" },
    react_1["default"].createElement(react_select_1.components.Option, __assign({}, props, { className: (0, classnames_1["default"])(Select_module_scss_1["default"].option, props.isFocused && Select_module_scss_1["default"].focusedOption, props.isSelected && Select_module_scss_1["default"].selectedOption, props.isDisabled && Select_module_scss_1["default"].disabledOption) })))); };
var NoOptionsMessage = function (props) { return (react_1["default"].createElement(react_select_1.components.NoOptionsMessage, __assign({}, props),
    react_1["default"].createElement("span", { className: Select_module_scss_1["default"].noOptionsMessage }, props.children))); };
var SingleValue = function (props) { return (react_1["default"].createElement(react_select_1.components.SingleValue, __assign({}, props, { className: Select_module_scss_1["default"].singleValueOverrides }),
    react_1["default"].createElement("span", { className: Select_module_scss_1["default"].singleValue }, props.children))); };
var MultiValue = function (props) { return (react_1["default"].createElement("div", { className: Select_module_scss_1["default"].multiValue },
    react_1["default"].createElement(draft_tag_1.Tag, { variant: "default", dismissible: true, inline: true, onDismiss: props.removeProps.onClick }, props.children))); };
var IndicatorsContainer = function (props) { return (react_1["default"].createElement(react_select_1.components.IndicatorsContainer, __assign({}, props, { className: Select_module_scss_1["default"].indicatorsContainer }))); };
var Input = function (props) { return (react_1["default"].createElement(react_select_1.components.Input, __assign({ className: Select_module_scss_1["default"].input }, props))); };
var ValueContainer = function (props) { return (react_1["default"].createElement(react_select_1.components.ValueContainer, __assign({}, props, { className: Select_module_scss_1["default"].valueContainer }))); };
var ClearIndicator = function (props) { return (react_1["default"].createElement(react_select_1.components.ClearIndicator, __assign({}, props, { className: Select_module_scss_1["default"].clearIndicator }),
    react_1["default"].createElement(component_library_1.Icon, { icon: clear_icon_svg_1["default"], role: "presentation" }))); };
//# sourceMappingURL=Select.js.map